const LAYOUT = {
  TABLET_RESOLUTION: '@media screen and (max-width: 1250px)',
  MOBILE_RESOLUTION: '@media screen and (max-width: 899px)',
  // MOBILE_LITTLE_RESOLUTION: '@media screen and (max-width: 399px)',
};

export default LAYOUT;
